import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const PhoneIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Phone</title>
    <path d="M30,4H18a4,4,0,0,0-4,4V40a4,4,0,0,0,4,4H30a4,4,0,0,0,4-4V8A4,4,0,0,0,30,4ZM22.5,5h3a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5A.5.5,0,0,1,22.5,5ZM24,42.5A1.5,1.5,0,1,1,25.5,41,1.5,1.5,0,0,1,24,42.5ZM31,37H17V9H31Z" />
  </IconBase>
);
